<template>

<div class="vin-label">
  <svg xmlns="http://www.w3.org/2000/svg"  class="vin-label__svg" viewBox="0 0 10 6" width="10" height="8">
  <g data-name="Layer 2">
    <path fill="none" stroke="#ee2300" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1L5 5 3.04 3.04 1 1" data-name="Layer 1"/>
  </g>
</svg>
  <span class="vin-label__text">
    {{labelText}}
    <sup>*</sup>
  </span>
  <v-select 
    :placeholder="placeholder" 
    class="vin-label__select"
    maxHeight="190px"
    ref="vSelect"
    :value="value"
    :label="selectLabel"
    :disabled="disabled"
    :options="localOpt"
    @input="(value)=> $emit('input', value)"
    >
    <div 
      v-if="defaultText" 
      slot="no-options"
    >
      {{defaultText}}
    </div>
  </v-select>
  <span
    class="vin-label__error"
    v-if="errorText">
    {{errorText}}
  </span>
</div>

</template>

<script>
export default {
  props: {
    labelText: {
      type: String
    },
    selectLabel: {
      type: String,
      default: "label"
    },
    errorText: {
      type: String
    },
    options: {
      type: Array,
    },
    placeholder: {
      type: String,
    },
    defaultText : {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: null
    }
  },
  data:() => ({
    localOpt: []
  }),
  created() {
    this.localOpt = this.options ? this.options : [];
  },
  watch: {
    options(v){
    this.localOpt = v}
  },
  methods: {
    clear() {

      this.$refs.vSelect.clearSelection();
      this.localOpt = [];
      // this.$refs.vSelect
      // console.log(this.$refs.vSelect);
    }
  }
}
</script>

<style lang="sass">
@import '@/assets/sass/partials/_sass-components.sass'
.vin-label__select.v-select.single
  width: 370px
  height: 48px
  border-radius: 4px
  background-color: $grey
  margin-bottom: 5px
  transition: background .3s
  position: relative
  +res('desk')
    &:hover
      background-color: $form-hover
  +res('mob')
    max-width: 100%
    margin: auto
  &.open
    border-bottom-left-radius: 0
    border-bottom-right-radius: 0
    background-color: $form-hover

    .open-indicator:before
      // background: url('~/assets/svg/icon_arrow.svg') 0 0 no-repeat
      // content: ''
      // width: 10px
      // height: 10px
      display: none

    .selected-tag
      position: relative
      padding: 0
      margin: 0
      font-size: 15px
      font-weight: 300
      padding-left: 20px

  input[type=search]
    padding: 0
    font-size: 15px
    font-weight: 300
    color: $black
    padding-left: 20px
  
  input:invalid
    box-shadow: none

  .selected-tag
    position: relative
    padding: 0
    display: inline-block !important
    margin: 0
    font-size: 15px
    font-weight: 300
    padding-left: 20px
    width: 270px
    margin-top: 13px !important
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

  .open-indicator:before
    // background: url('/img/icon_arrow.svg') 0 0 no-repeat
    // content: ''
    // width: 10px
    // height: 10px
    display: none

  .dropdown-toggle
    border: none
    font-family: $text-font-book
    height: 100%

  .vs__actions
    // width: 20px
    // position: absolute
    // right: 40px
    // top: 50%
    // transform: translateY(-50%)
    display: none

  .dropdown-menu
    overflow: auto
    border-style: none
    padding: 0
    // box-shadow: none
    scrollbar-width: thin
    scrollbar-color: #d1cfd1
    scrollbar-width: 6px

    &::-webkit-scrollbar
      width: 6px
      height: 0

    &::-webkit-scrollbar-track 
      background-color: #f4f3f4

    &::-webkit-scrollbar-thumb 
      background-color: #d1cfd1
      opacity: 0.2

    li
      height: 48px
      font-family: $text-font-book
      border-top: 1px solid rgba(0,0,0,.05)
      background: #f0f0f0
      font-size: 15px
      font-weight: 300
      padding-left: 20px
      +res('desk')
        &:hover
          background-color: $form-hover

      &.active > a,
      &.highlight > a
        color: $black

      & > a
        padding: 0
        background: transparent
        line-height: 45px
.vin-label
  position: relative
  margin-bottom: 20px

  &.deactive .vin-label__select
    pointer-events: none

  &__svg
    position: absolute
    pointer-events: none
    right: 20px
    bottom: 24px
    z-index: 1
    +res('mob')
      bottom: 20px

.form-control
  &::-webkit-input-placeholder
    color: $black
    opacity: 1
  &::-moz-placeholder
    color: $black
    opacity: 1
  &:-moz-placeholder
    color: $black
    opacity: 1
  &:-ms-input-placeholder
    color: $black
    opacity: 1

.select-dillers
  pointer-events: auto
  &.deactive
    position: none
    opacity: .7
</style>
